<template>
  <div class="search__products-item">
    <a
      class="search__products-anchor"
      :href="url"
      data-tracking-event="event"
      data-tracking-category="navigation"
      data-tracking-action="fly-out klick"
      :data-tracking-label="name"
      :data-index="index"
    >
      <img 
        :src="imageUrl"
        :title="name"
        alt="Jungheinrich Profishop-Transportkarren"
        class="search__products-image"
      >
        <div class="search__products-text-wrapper">
          <div class="search__products-name" v-html="highlightedName"></div>
          <div v-if="minPrice.length && oldPrice.length" class="search__products-price">
            <span class="search__products-price-new">{{ minPrice }}</span>
            <span class="search__products-price-old">{{ oldPrice }}</span>
          </div>
          <div v-else class="search__products-price">
             <span v-if="minPrice.length" class="search__products-price-current">{{ minPrice }}</span>
          </div>
        </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    highlightedName: {
      type: String,
      required: true
    },
    imageUrl: String,
    oldPrice: String,
    minPrice: String,
    index: Number
  }
}
</script>
